import { getVietnamDateKey } from "@/lib/topup-promo";

/** Không khí Ngày Nhà Giáo Việt Nam 20/11 — phủ header từ cuối 10 đến hết tháng điểm danh 11. */
export const TEACHERS_DAY_SEASON_START = "2026-10-29";
export const TEACHERS_DAY_SEASON_END = "2026-11-30";
export const TEACHERS_DAY_LABEL = "Ngày Nhà Giáo Việt Nam 20/11";

export function isTeachersDaySeason(date: Date = new Date()): boolean {
  const key = getVietnamDateKey(date);
  return key >= TEACHERS_DAY_SEASON_START && key <= TEACHERS_DAY_SEASON_END;
}
